<script lang="ts">
    import { room } from "../lib/room.svelte.ts";
</script>

<div class="logo-bar">
    {#if room.logoIconImage}
        <img class="logo-icon" src={room.logoIconImage} alt="logo icon" />
    {/if}

    {#if room.logoNameImage}
        <img class="logo-name" src={room.logoNameImage} alt={room.worldTitle} />
    {:else}
        <span class="logo-text">{room.worldTitle}</span>
    {/if}
</div>

<style>
    .logo-bar {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.4rem 0;
        min-height: 2.5rem;
        flex-shrink: 0;
    }

    .logo-icon {
        height: 2rem;
        width: auto;
        object-fit: contain;
        opacity: 0.85;
    }

    .logo-name {
        height: 2rem;
        width: auto;
        max-width: 100%;
        object-fit: contain;
        opacity: 0.85;
    }

    .logo-text {
        font-family: 'Courier New', Courier, monospace;
        font-size: 1rem;
        letter-spacing: 0.3em;
        color: #9a8c70;
        text-transform: uppercase;
    }
</style>
